import { SESSION_AUTHORIZE, SESSION_START, SESSION_END, SESSION_ERROR } from '../Actions/AuthActions';

const initial_state = {
  authorizing: false,
  errorAuth: false,
  jwt: null,
};

export function authorization(state = initial_state, action) {
  switch (action.type) {
    case SESSION_AUTHORIZE:
      return {
        ...state,
        authorizing: true,
        errorAuth: false,
      };
    case SESSION_START:
      return {
        ...state,
        authorizing: false,
        errorAuth: false,
        jwt: action.jwt,
        access_token: action.access_token,
      };
    case SESSION_END:
      return {
        ...state,
        authorizing: false,
        errorAuth: false,
        jwt: null,
        access_token: null,
      };
    case SESSION_ERROR:
      return {
        ...state,
        authorizing: false,
        errorAuth: true,
        errorMessage: action.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/AuthReducer.js